// extracted by mini-css-extract-plugin
module.exports = {"preLoader":"Preloader_preLoader__TXN4g"};